import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ChiSiamoPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="pt-32 pb-24 bg-gradient-to-br from-blue-50 to-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center px-6 py-2 border-2 border-gray-800 rounded-full mb-12">
            <span className="text-sm font-medium text-gray-800 uppercase tracking-wider">Chi Siamo</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-light text-gray-900 mb-8 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Amaca S.r.l. è il tuo<br />
            <span className="inline-flex items-center">
              partner tecnologico
              <span className="inline-block w-16 h-16 mx-4">
                <i className="ri-hand-heart-line text-5xl text-blue-600"></i>
              </span>
            </span>
            <br />
            <span className="inline-flex items-center">
              per la distribuzione
              <span className="inline-block w-16 h-16 mx-4">
                <i className="ri-truck-line text-5xl text-blue-600"></i>
              </span>
            </span>
            <br />
            all'ingrosso dal 2020
            <span className="inline-block w-16 h-16 ml-4">
              <i className="ri-award-line text-5xl text-blue-600"></i>
            </span>
          </h1>
        </div>
      </section>
      
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">La Nostra Storia</h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Amaca S.r.l. nasce nel 2020 con l'obiettivo di diventare un punto di riferimento nel commercio all'ingrosso di tecnologia in Campania. Con sede a Casandrino, in provincia di Napoli, serviamo rivenditori, system integrator e aziende in tutta Italia.
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                La nostra missione è fornire prodotti tecnologici di qualità a prezzi competitivi, garantendo un servizio clienti eccellente e consegne rapide. Collaboriamo con i principali brand del settore per offrire un catalogo sempre aggiornato.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Grazie alla nostra esperienza e professionalità, abbiamo costruito relazioni durature con centinaia di clienti che si affidano a noi per le loro forniture tecnologiche.
              </p>
            </div>
            
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/bb25ef6d255141cd729a21d6adb3bbfc.jpg"
                alt="Magazzino Amaca"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>
      
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">I Nostri Valori</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Qualità</h3>
              <p className="text-gray-600 leading-relaxed">
                Selezioniamo solo prodotti originali e certificati dai migliori brand del settore tecnologico, garantendo qualità e affidabilità.
              </p>
            </div>
            
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-customer-service-2-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Servizio</h3>
              <p className="text-gray-600 leading-relaxed">
                Il cliente è al centro della nostra attività. Offriamo supporto dedicato, consulenza professionale e assistenza continua.
              </p>
            </div>
            
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-rocket-line text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Innovazione</h3>
              <p className="text-gray-600 leading-relaxed">
                Rimaniamo sempre aggiornati sulle ultime tecnologie per offrire ai nostri clienti i prodotti più innovativi del mercato.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Informazioni Aziendali</h2>
          <div className="bg-gray-50 rounded-2xl p-10 text-left">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <p className="text-sm text-gray-600 mb-1">Ragione Sociale</p>
                <p className="text-lg font-semibold text-gray-900">Amaca S.r.l.</p>
              </div>
              <div>
                <p className="text-sm text-gray-600 mb-1">Partita IVA</p>
                <p className="text-lg font-semibold text-gray-900">10914011217</p>
              </div>
              <div>
                <p className="text-sm text-gray-600 mb-1">Sede Legale</p>
                <p className="text-lg font-semibold text-gray-900">Via Don Domenico D'Angelo 31<br />80025 Casandrino (NA)</p>
              </div>
              <div>
                <p className="text-sm text-gray-600 mb-1">Contatti</p>
                <p className="text-lg font-semibold text-gray-900">
                  Tel: 350 862 8049<br />
                  Email: ordini.amacasrl@gmail.com<br />
                  PEC: amacasrl2025@pec.it
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default ChiSiamoPage;
